/**
 * Import from node_modules
 */
// import 'bootstrap/js/src/scrollspy';

/**
 * Import site scripts
 */
import Menu from './site/menu';
import ScrollTo from './site/scrollTo';
import Header from './site/header';
import AnimatePath from './site/animatePath';
import ScrollReveal from './shared/scrollReveal';

/**
 * Init site scripts
 */
jQuery(function() {
	Menu.init();
	ScrollTo.init();
	Header.init();
	AnimatePath.init();
	ScrollReveal.init();
});
